import { AccountCountryLegalRequirements } from '../_models';

export class CountryLegalRequirementsResponse {
    public requirements: AccountCountryLegalRequirements[];
}